module.exports = "<div class=\"m-measure-tooltip measure\">Area: {{area}}</div>";